module.exports = __webpack_public_path__ + "media/images/sports_icons/010-yoga-59e12de28f27e23316653b3f8f8e64e3.png";